




import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { IUCHeroGalleryItem } from '@shared/components/@organisms/UCHeroGallery/types';
import UCHeroGallery from '@shared/components/@organisms/UCHeroGallery/UCHeroGallery.vue';
import { ISBHeroGalleryItem } from '@shared/components/@storyblok/StoryblokHeroGallery/types';
import useResponsive from '@shared/composables/useResponsive';

import { transformUCHeroGalleryItem } from './helpers';

export default defineComponent({
  name: 'StoryblokHeroGallery',
  components: {
    UCHeroGallery,
  },
  props: {
    slides: {
      type: Array as PropType<ISBHeroGalleryItem[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { isMobile } = useResponsive();

    const transformedSlides = computed<IUCHeroGalleryItem[]>(() =>
      props.slides.map(transformUCHeroGalleryItem),
    );

    return {
      isMobile,
      transformedSlides,
    };
  },
});
